import { buildModelManager } from "../builder.js";
const DefaultStripeConnectAccountSelection = {
  __typename: true,
  id: true,
  chargesEnabled: true,
  country: true,
  createdAt: true,
  defaultCurrency: true,
  detailsSubmitted: true,
  livemode: true,
  payoutsEnabled: true,
  profileId: true,
  requirementsCurrentlyDue: true,
  requirementsPastDue: true,
  stripeId: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "stripeConnectAccount";
const pluralModelApiIdentifier = "stripeConnectAccounts";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripeConnectAccountSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripeConnectAccountSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeConnectAccountSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeConnectAccountSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeConnectAccountSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripeConnectAccountSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripeConnectAccountSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByStripeId",
    findByField: "stripeId",
    findByVariableName: "stripeId",
    modelApiIdentifier,
    defaultSelection: DefaultStripeConnectAccountSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByStripeId",
    findByField: "stripeId",
    findByVariableName: "stripeId",
    modelApiIdentifier,
    defaultSelection: DefaultStripeConnectAccountSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "stripeConnectAccountGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const StripeConnectAccountManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultStripeConnectAccountSelection,
  operations
);
export {
  DefaultStripeConnectAccountSelection,
  StripeConnectAccountManager
};
//# sourceMappingURL=StripeConnectAccount.js.map
